export const footerStyles = {
  wrapper: {
    position: "relative",
    margin: "auto",
  },
};
